import { START_EVENTS_LOADING } from "./types";

const toggleBookingsLoading = () => ({
  type: START_EVENTS_LOADING,
});

export default toggleBookingsLoading;
